import { useMutation, useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from 'constants/endpoints';
import { del, get, handleError, handleResponse, post, put } from './base.service';

export const useCompanyDetailsQuery = (id: any) =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.COMPANY_DETAILS}/${id}`);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['companyDetails'],
		enabled: !!id,
	});

export const useUpdateCompanyDetailsMutation = () =>
	useMutation({
		mutationFn: (payload: any) => {
			return post(API_ENDPOINTS.COMPANY_UPDATE_PROFILE, payload);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});

export const useCompanyDetailsMutation = () =>
	useMutation({
		mutationFn: async (id: any) => {
			try {
				const response = await get(`${API_ENDPOINTS.COMPANY_DETAILS}/${id}`);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
	});

export const useGetHiringBoardListQuery = (payload: any) =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(
					`${API_ENDPOINTS.GET_HIRING_BOARD_LIST}?order=${payload.order}&page=1&limit=${5 * payload.currentPage}&hasExpired=false&inActive=false&type=all&jobId=${payload.jobID}&jobStatus=${payload.jobStatus}`,
				);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: [payload?.jobStatus],
		refetchOnWindowFocus: false,
	});

export const useChangeHiringBoardStatusMutation = () =>
	useMutation({
		mutationFn: async (payload: any) => {
			try {
				const response = await put(
					`${API_ENDPOINTS.CHANGE_HIRING_BOARD_STATUS}/${payload?.id}`,
					payload?.data,
				);
				return handleResponse(response);
			} catch (error) {
				handleError(error);
			}
		},
	});

export const useRejectCandidateMutation = () =>
	useMutation({
		mutationFn: async (payload: any) => {
			try {
				const response = await post(`${API_ENDPOINTS.REJECT_CANDIDATE}`, payload);
				return handleResponse(response);
			} catch (error) {
				handleError(error);
			}
		},
	});

export const useAddToTalentMutation = () =>
	useMutation({
		mutationFn: async (payload: any) => {
			try {
				const response = await post(`${API_ENDPOINTS.COMPANY_TALENT}`, payload);
				return handleResponse(response);
			} catch (error) {
				handleError(error);
			}
		},
	});

export const useGetSavedTalentListQuery = (payload: any) =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(
					`${API_ENDPOINTS.COMPANY_TALENT}?order=${payload.order}&page=${payload.currentPage}&limit=${5}&userId=${payload.userId}`,
				);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['get-saved-talent'],
		refetchOnWindowFocus: false,
	});

export const useFollowCompanyMutation = () =>
	useMutation({
		mutationFn: async (payload: any) => {
			try {
				const response = await post(`${API_ENDPOINTS.FOLLOW_COMPANY}`, payload);
				return response;
			} catch (error) {
				handleError(error);
			}
		},
	});

export const useRemoveAssessmentMutation = () =>
	useMutation({
		mutationFn: async (id: number) => {
			try {
				const response = await del(`${API_ENDPOINTS.DELETE_ASSESSMENT}/${id}`);
				return response;
			} catch (error) {
				handleError(error);
			}
		},
	});
